import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  errorHandling:['loggingData'],
  showToastMsg:['content', 'typeOption'],
  setCurrentUser: ['currentUser'],
  setCurrentUserSuccess: ['currentUser'],
  setIsOpenSubmenu: ['isOpenSubmenu'],
});

export const BaseTypes = Types;
export default Creators;
